import { FILTERS_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setSearch = dispatch => search => dispatch({
  type: ACTION_TYPE.SET_SEARCH,
  payload: {
    searchInput: search
  }
});
const setSortBy = dispatch => sort => dispatch({
  type: ACTION_TYPE.SET_SORT_BY,
  payload: {
    sortValue: sort
  }
});
const setFilterByTaggedStatus = dispatch => taggedStatus => dispatch({
  type: ACTION_TYPE.SET_FILTER_BY_TAGGED_STATUS,
  payload: {
    filterByTaggedStatus: taggedStatus
  }
});
const setFilterDisabled = dispatch => disabled => dispatch({
  type: ACTION_TYPE.SET_DISABLED,
  payload: {
    filterDisabled: disabled
  }
});
const setSelectedThemes = dispatch => selected => dispatch({
  type: ACTION_TYPE.SET_SELECTED_THEMES,
  payload: {
    selectedThemes: selected
  }
});
const setSelectedStimuli = dispatch => selected => dispatch({
  type: ACTION_TYPE.SET_SELECTED_STIMULI,
  payload: {
    selectedStimuli: selected
  }
});
const setSelectedSentiment = dispatch => selected => dispatch({
  type: ACTION_TYPE.SET_SELECTED_SENTIMENT,
  payload: {
    selectedSentiment: selected
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setSearch,
  setSortBy,
  setFilterByTaggedStatus,
  setFilterDisabled,
  setSelectedThemes,
  setSelectedStimuli,
  setMultiple,
  setSelectedSentiment
};